module.exports = __webpack_public_path__ + "static/media/twitter-logo.5c23880d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/twitter-logo.svg
// module id = 1697
// module chunks = 0